import { call, delay, put, select } from 'redux-saga/effects';
import { ConnectCin7EntityRequestAction } from '../types';
import { ApiError, ApiResponse } from 'store/api/types';
import { MessageData } from 'store/app/types';
import { MessageStates } from 'containers/MessageBox';
import { turnMessageOn } from 'store/app/actions';
import { checkResponse } from 'store/utils';
import {
  connectCin7EntityFailure,
  connectCin7EntitySuccess,
  fetchOrganisationsRequest,
} from '../actions';
import { connectCin7Entity } from '../api';
import { logoutRequest } from 'store/auth/actions';
import { fetchViesInfoRequest } from 'store/vat-checker/actions';
import { getAuthUser } from 'store/auth/selectors';
import { push } from 'store/navigation/actions';
import routes from 'routes';
import { renderErrorMessage } from 'utils/render-error-message';
import i18n from 'i18next';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* connectCin7EntitySaga(action: ConnectCin7EntityRequestAction) {
  try {
    let err: ApiError | null;

    const { key, cin7accountId, orgName } = action.payload;
    const response: ApiResponse = yield call(
      connectCin7Entity,
      key,
      cin7accountId,
      orgName
    );
    //const orgUrl: string = response.data.url;

    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    yield put(fetchOrganisationsRequest());
    yield delay(3000);
    const currentUser = yield select(getAuthUser);
    currentUser &&
      localStorage.removeItem(`vies-infos-${currentUser.userUuid}`);
    yield put(fetchViesInfoRequest());
    const message: MessageData = {
      title: i18n.t('notifications.entity-connected'),
      description: i18n.t('notifications.cin7-entity-succesfully-connected'),
      type: MessageStates.INFO,
    };
    yield put(turnMessageOn(message));
    yield put(connectCin7EntitySuccess());
    yield put(push(routes.vies.qualifiedEntities));
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(connectCin7EntityFailure());
  }
}
